// Shared Stripe Elements theme so the checkout and saved-card forms match the app's
// brand tokens (styles.css) instead of Stripe's default look.
import { Appearance } from '@stripe/stripe-js';

export const STRIPE_APPEARANCE: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#457B9D',
    colorText: '#1D3557',
    colorTextSecondary: '#64748b',
    colorDanger: '#dc2626',
    colorBackground: '#ffffff',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSizeBase: '15px',
    borderRadius: '10px',
    spacingUnit: '4px',
    focusBoxShadow: '0 0 0 3px rgba(69, 123, 157, 0.2)',
  },
  rules: {
    '.Input': {
      border: '1px solid #e2e8f0',
      boxShadow: 'none',
      padding: '12px 14px',
    },
    '.Input:focus': {
      borderColor: '#457B9D',
    },
    '.Label': {
      fontWeight: '600',
      color: '#1D3557',
      marginBottom: '6px',
    },
    '.Tab': {
      border: '1px solid #e2e8f0',
      boxShadow: 'none',
    },
    '.Tab--selected': {
      borderColor: '#457B9D',
      boxShadow: '0 0 0 1px #457B9D',
    },
  },
};
